import { Method, Request, sendRequest } from "@myloc/myloc-utils";
import { api } from "../../config/settings";
import defaultRestOptions from "../utils/defaultRestOptions";
import { RegisterActionRequest } from "./types";

async function getLogisticsOrderDefinitions(inventoryId: string) {
  const url = api.registerAction.orderDefinitions(inventoryId);
  const request = new Request(url, Method.GET);

  return await sendRequest(request, {}, await defaultRestOptions());
}

async function getFormMapping(inventoryId: string, definitionId: string) {
  const url = api.registerAction.formMapping(inventoryId);

  url.addParameter("definitionId", decodeURIComponent(definitionId));

  const request = new Request(url, Method.GET);

  return await sendRequest(request, {}, await defaultRestOptions());
}

async function registerAction(inventoryId: string, data: RegisterActionRequest) {
  const url = api.registerAction.register(inventoryId);
  const request = new Request(url, Method.POST);

  return await sendRequest(request, data, await defaultRestOptions());
}

export default {
  getLogisticsOrderDefinitions,
  getFormMapping,
  registerAction,
};
